<template>
  <b-col cols="12" sm="12">
    <div>
      <a class="btnVolver" @click="$router.push({ path: 'usuarios' })" title="Cerrar">
        <feather id="btnX" type="arrow-left-circle"></feather>
      </a>
    </div>
    <b-card class="mx-auto" tile>
      <div v-if="!submitted">
        <span>*{{ this.$t("Gral.camposObligatorios") }}</span>
        <p v-if="noAdmins" class="text-danger text-center">
          Para cambiar el rol del usuario:
          <strong> {{ usuario.matricula }}</strong> primero debe registrar un usuario
          Administrador al grupo.
        </p>
        <b-form @submit.stop.prevent="updateUsuario" style="z-index: 1">
          <b-col cols="12" sm="12">
            <div class="row">
              <b-col cols="12" sm="6">
                <label for="“matricula”">{{ this.$t("Gral.usuario") }}: *</label>
                <b-form-input id="matricula" :rules="[(v) => !!v || 'Usuario obligatorio']" v-model="usuario.matricula"
                  required>
                </b-form-input>
                <b-form-invalid-feedback id="matricula-invalid">
                  {{ this.$t("vUsuarios.msgNombreUser") }}
                </b-form-invalid-feedback>
              </b-col>
              <b-col v-if="master" cols="12" sm="6">
                <b-form-group id="input-group-3" :label="$t('vUsuarios.rol') + ': *'">
                  <b-form-select v-model="usuario.role" :options="roles" value-field="id" text-field="role" required
                    @input="removeAdminActual(usuario.role)">
                  </b-form-select>
                </b-form-group>
              </b-col>
            </div>

            <div v-if="master && usuario.role != idMaster" class="row">
              <b-col cols="12" sm="6">
                <label for="nombre">{{ $t("vDispositivos.msgGrupo") }}: *</label>
                <multiselect id="area" v-model="selectedArea" :options="areas" :multiple="isAdmin"
                  :placeholder="$t('Gral.escribaBuscar')" track-by="id" label="nombre" @input="onAreaInput"
                  :class="areaClass">
                </multiselect>
              </b-col>
            </div>
            <b-row>
              <div class="col-12 col-sm-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-lg-flex justify-content-lg-end">
                <b-btn color="primary" class="ancho-boton w-100" style="color: white" to="/Usuarios">
                  {{ this.$t("Gral.cancelar") }}
                </b-btn>
              </div>
              <div class="col-12 col-sm-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 sepracion-div-boton-guardar">
                <b-btn variant="info" class="ancho-boton w-100" style="color: white" :disabled="noAdmins" type="submit">
                  {{ this.$t("vUsuarios.saveUser") }}
                </b-btn>
              </div>
            </b-row>
          </b-col>
        </b-form>
      </div>
    </b-card>
  </b-col>
</template>

<script src="js/main.js"></script>
<script>
import UsersDataService from "../../../services/UsersDataService";
import AreaDataService from "../../../services/AreaDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import Crypto from "../../../services/Crypto";

import { generalSweetAlert } from "../../../utils/Utils";
import { verificarAcceso } from "../../../utils/Session";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "edit-usuario",
  components: { Multiselect },
  data() {
    return {
      roles: this.obtenerTodosRoles(),
      areas: [],
      master: false,
      idMaster: process.env.VUE_APP_ID_MASTER,
      idFinal: process.env.VUE_APP_ID_USUARIO_FINAL,
      usuario: {
        id: 0,
        matricula: "",
        contrasena: "",
        nombre: "",
        apellido: "",
        extra: "",
        rol: null,
        role: null,
        area: null,
        administrador: "",
        areaIds: [],
      },
      selectedArea: null,
      submitted: false,
      accion: "",
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      key: "",
      usuariosAdmin: [],
      noAdmins: false,
    };
  },
  beforeCreate() {
    verificarAcceso();
    if (
      !sessionStorage.getItem("rol") ||
      sessionStorage.idRol === process.env.VUE_APP_ID_USUARIO_FINAL
    ) {
      this.$router.push({
        path: "/monitoreo",
      });

      generalSweetAlert(this.$t("vDispositivos.noPermisos"), "error");
    }
  },
  mounted() {
    this.key = sessionStorage.getItem("key");
    this.mostrarUsuario(this.$route.params);

    this.obtenerAreas();
  },

  computed: {
    isAdmin() {
      return this.usuario.role === "6081c4becaae9b0d5e87e61b";
    },

    areaClass() {
      return { "is-invalid": this.areaInvalida };
    },
  },


  watch: {
    isAdmin(newVal) {

      if (newVal) {
        //asegurar array
        if (this.selectedArea == null) this.selectedArea = [];
        else if (!Array.isArray(this.selectedArea)) this.selectedArea = [this.selectedArea];
      } else {
        // pasar a single -> tomar el primero o null
        if (Array.isArray(this.selectedArea)) {
          this.selectedArea = this.selectedArea 
        }else{
          this.selectedArea = this.selectedArea
        }
      }
    }
  },

  methods: {
    validateArea() {
      if (this.isAdmin) {
        this.areaInvalida = !(
          Array.isArray(this.selectedArea) && this.selectedArea.length > 0
        );
      } else {
        this.areaInvalida = !(
          this.selectedArea &&
          (typeof this.selectedArea === "object"
            ? this.selectedArea.id
            : this.selectedArea)
        );
      }
      return !this.areaInvalida;
    },

    // Normaliza selectedArea (obj | [obj]) y luego valida y emite
    onAreaInput(val) {
      // val puede ser objeto único o array de objetos dependiendo de :multiple
      this.selectedArea = val;

      if (this.isAdmin) {
        // selectedArea debe ser array de objetos
        const ids = Array.isArray(this.selectedArea) ? this.selectedArea.map(a => a.id) : [];
        // sincronizamos estado del usuario
        this.usuario.areaIds = ids;           // lista de ids (para backend)
        // guardamos también area como array (si tu servicio espera array en usuario.area)
        this.usuario.area = Array.isArray(this.selectedArea) ? this.selectedArea.map(a => ({ id: a.id })) : [];
        // cargar admins para la primera area (si aplica)
        if (ids.length) this.usuariosByRolAndArea(ids[0]);
      } else {
        // single select: objeto o null
        const id = this.selectedArea ? this.selectedArea.id : null;
        this.usuario.areaIds = [];            // no aplica para usuario normal
        // guardar area como id o como objeto según tu convención (aquí guardamos id)
        this.usuario.area = id;
        if (id) this.usuariosByRolAndArea(id);
      }

      // emitir (si alguien lo escucha)
      // this.$emit('input', this.isAdmin ? this.usuario.areaIds : this.usuario.area);

      // validar cada vez que cambia
      this.validateArea();
    },


    mostrarUsuario(datos) {

      this.usuario.nombre = datos.nombre;
      this.usuario.apellido = datos.apellido;
      this.usuario.id = datos.id;
      this.usuario.matricula = datos.matricula;
      this.usuario.extra = datos.extra;
      this.usuario.contrasena = datos.contrasena;
      this.usuario.rol = datos.role;
      this.usuario.role = datos.role == null ? "NULL" : datos.role.id;
      this.usuario.areaIds = datos.areaIds;
      if (datos.area == null) {
        this.usuario.area = null;
      } else {
        this.usuario.area = datos.area == null ? "NULL" : datos.area.id;
        this.usuariosByRolAndArea(datos.area.id);
      }

      if (datos.administrador == null) {
        this.usuario.administrador = null;
      } else {
        this.usuario.administrador =
          datos.administrador == null ? "NULL" : datos.administrador;
      }

      this.usuario.habilitado = datos.habilitado;

      this.setSelectedAreaFromUsuario();
    },

    async usuariosByRolAndArea(idArea) {
      try {
        const res = await UsersDataService.getUsuariosByRolAndArea(
          idArea,
          this.key
        );
        this.usuariosAdmin = res.data;
      } catch (error) {
        generalSweetAlert(this.$t("Gral.msgErrorDesconocido"), "error");
      }
    },

    updateUsuario() {
      let administrador = "";

      if (this.usuario.role == process.env.VUE_APP_ID_MASTER) {
        this.usuario.area = null;
      }
      if (!this.master) {
        this.usuario.role = process.env.VUE_APP_ID_USUARIO_FINAL;
      }

      if (this.usuario.role === process.env.VUE_APP_ID_ADMINISTRADOR) {
        administrador = administrador;
      }

      if(this.usuario.role === process.env.VUE_APP_ID_USUARIO_FINAL){
        const adminEncontrado = this.usuariosAdmin
        .find(item => item.id === this.usuario.administrador);

        administrador = adminEncontrado ? adminEncontrado.id : null;
      }

        let areaPayload = null;
        let areaIds = [];

        if (this.isAdmin) {
          if (Array.isArray(this.selectedArea) && this.selectedArea.length > 0) {
            areaPayload = this.selectedArea[0];            // primer objeto del array
            areaIds = this.selectedArea.map(a => a.id);    // todos los ids
          } else if (this.selectedArea && typeof this.selectedArea === 'object') {
            areaPayload = this.selectedArea;
            areaIds = [this.selectedArea.id];
          } else {
            areaPayload = null;
            areaIds = [];
          }
        } else {

          // usuario normal
          areaPayload = this.selectedArea.length ? this.selectedArea[0] : this.selectedArea
          areaIds = [];
        }

        const data = {
          nombre: this.usuario.nombre,
          apellido: this.usuario.apellido,
          id: this.usuario.id,
          matricula: this.usuario.matricula,
          extra: this.usuario.extra,
          rol: this.roles.find((item) => item.id === this.usuario.role),
          habilitado: this.usuario.habilitado,
          // enviamos area como objeto y areaIds como lista (vacía si no es admin)
          area: areaPayload,
          areaIds: areaIds,
          administrador: administrador ?? null,
        };

      UsersDataService.update(data, this.key)
        .then(async (res) => {
          this.accion = "Actualizó al usuario " + data.matricula;
          this.registrarAccion();

          generalSweetAlert(this.$t("vUsuarios.msgUserAct"), "success");
          this.$router.push("/usuarios");
        })
        .catch(async (e) => {
          console.log("error update:: ",e);
          
          var titulo;
          var decoded = await Crypto.desencriptar(e.response.data, this.key);
          if (e.response.status === 400 && decoded === 1) {
            titulo = this.$t("vUsuarios.userErr1");
          } else {
            titulo = this.$t("vUsuarios.msgErrRegUser");
          }

          generalSweetAlert(titulo, "error");
        });
    },

    removeAdminActual(role) {
      if (role === process.env.VUE_APP_ID_USUARIO_FINAL) {
        this.usuariosAdmin = this.usuariosAdmin.filter(
          (user) => user.id !== this.usuario.id
        );

        if (this.usuariosAdmin.length === 0) {
          this.noAdmins = true;
          return;
        }
      }

      if (role === process.env.VUE_APP_ID_ADMINISTRADOR) {
        this.noAdmins = false;
        return;
      }
    },

    selectArea(id) {
      this.usuariosByRolAndArea(id);
    },

    async usuariosByRolAndArea(idArea) {
      try {
        const res = await UsersDataService.getUsuariosByRolAndArea(
          idArea,
          this.key
        );
        this.usuariosAdmin = res.data;
        
        this.usuariosAdmin = this.usuariosAdmin.filter(
          (usuario) => usuario.habilitado !== false
        );

        if (this.usuariosAdmin.length > 0) {
          this.noAdmins = false;
        }
      } catch (error) {
        generalSweetAlert(this.$t("Gral.msgErrorDesconocido"), "error");
      }
    },

    continuar() {
      this.submitted = false;
    },

    obtenerTodosRoles() {
      UsersDataService.getRoles()
        .then(async (response) => {
          this.roles = await Crypto.desencriptar(response.data, this.key);
        })
        .catch((e) => {});
    },
    obtenerAreas() {
      AreaDataService.getHabilitados().then(async (response) => {
        this.areas = await Crypto.desencriptar(response.data, this.key);
        /*if (sessionStorage.idRol == process.env.VUE_APP_ID_MASTER) {
          this.master = true;
        }*/
        this.master= this.esUsuarioMaster();

        this.setSelectedAreaFromUsuario();
      });
    },

    // setSelectedAreaFromUsuario() {
    //   // si aún no hay areas cargadas no hacemos nada
    //   if (!Array.isArray(this.areas) || this.areas.length === 0) {
    //     return;
    //   }

    //   // Si es admin, usuario.areaIds contiene los ids que administra (lista)
    //   if (this.isAdmin) {
    //     if (Array.isArray(this.usuario.areaIds) && this.usuario.areaIds.length > 0) {
    //       this.selectedArea = this.usuario.areaIds
    //         .map(id => this.areas.find(a => a.id === id))
    //         .filter(x => !!x);
    //     } else {
    //       this.selectedArea = [];
    //     }
    //   }
    //   // si no es admin, usuario.area contiene un id (string), seleccionamos el objeto
    //   else {
    //     if (this.usuario.area) {
    //       // usuario.area almacena el id en tu lógica actual
    //       this.selectedArea = this.areas.find(a => a.id === this.usuario.area) || null;
    //     } else {
    //       this.selectedArea = null;
    //     }
    //   }

    //   // validar la selección
    //   this.validateArea();
    // },

    setSelectedAreaFromUsuario() {
      // si aún no hay areas cargadas no hacemos nada
      if (!Array.isArray(this.areas) || this.areas.length === 0) {
        return;
      }

      // Cuando es admin, el multiselect es multiple (espera array)
      if (this.isAdmin) {
        // 1) Si vienen areaIds (lista de ids) -> mapeamos a objetos
        if (
          Array.isArray(this.usuario.areaIds) &&
          this.usuario.areaIds.length > 0
        ) {
          this.selectedArea = this.usuario.areaIds
            .map((id) => this.areas.find((a) => a.id === id))
            .filter((x) => !!x);
        }
        // 2) Si no vienen areaIds pero viene usuario.area (puede ser id o objeto)
        else if (this.usuario.area) {
          // usuario.area puede ser id (string) o un objeto { id, ... }
          const areaId =
            typeof this.usuario.area === "object" && this.usuario.area.id
              ? this.usuario.area.id
              : this.usuario.area; // si ya es id

          const found = this.areas.find((a) => a.id === areaId);
          this.selectedArea = found ? [found] : []; // array con 1 elemento para multiselect
        }
        // 3) nada -> lista vacía
        else {
          this.selectedArea = [];
        }
      }
      // cuando NO es admin: single select (selectedArea debe ser objeto o null)
      else {
        if (this.usuario.area) {
          const areaId =
            typeof this.usuario.area === "object" && this.usuario.area.id
              ? this.usuario.area.id
              : this.usuario.area;
          this.selectedArea = this.areas.find((a) => a.id === areaId) || null;
        } else {
          this.selectedArea = null;
        }
      }

      // validar la selección
      this.validateArea();
    },

    registrarAccion() {
      var data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(data, this.key);
    },

    esUsuarioMaster() {
        const isUserFiltradoString = sessionStorage.getItem("usuarioFiltro");
      
        if (isUserFiltradoString != 'null' && isUserFiltradoString != '' && isUserFiltradoString != null) {
            //Es un usuario master que accedio a vista de Administrador
            try {
                const isUserFiltrado = JSON.parse(isUserFiltradoString);

                if (isUserFiltrado.rol.id === "6081c4becaae9b0d5e87e61b") {
                    return false;
                }
            } catch (e) {
                console.error("Error al parsear usuarioFiltro:", e);
                return true;
            }
        } else {
          if (sessionStorage.idRol === "6081c4becaae9b0d5e87e61b") {
            // Es usuario administrador
            return false;
          }else if (sessionStorage.idRol == process.env.VUE_APP_ID_MASTER) {
            // 4. Comprobación final del rol Master (basado en el usuario logueado)
            return true;
          }
        }

        // Si ninguna condición se cumple, por defecto devolvemos false (si no es Master y si el filtro no era el especificado)
        return true;
    },

  },//END Methods
};
</script>

<style>
.myMargin {
  margin-left: 1rem;
}

.submit-form {
  max-width: 400px;
}

@media (max-width: 600px) {
  .card {
    margin-top: 10px !important;
  }
}

@media (max-width: 768px) {
  .btnVolver {
    position: absolute;
    top: -40px;
    left: 16px;
  }
}

@media (min-width: 769px) {
  .btnVolver {
    display: none !important;
  }
}

@media (max-width: 959px) {
  .sepracion-div-boton-guardar {
    margin-top: -12px;
  }
}

@media (min-width: 960px) {
  .sepracion-div-boton-guardar {
    margin-top: 0px;
  }
}

@media (min-width: 992px) {
  .ancho-boton {
    width: 300px !important;
  }
}
</style>
